import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export const shoppingCartText = {
  state: {
    link_manual: {
      th: process.env.MANUAL_URL_TH + '#shopping-cart-text',
      en: process.env.MANUAL_URL_EN + '#shopping-cart-text',
      vi: process.env.MANUAL_URL_VI + '#shopping-cart-text'
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/shopping_cart_text/index.js